import { UrlBuilder } from 'common/utils/url-builder';

export class ParametrizedAppRoute<TParams, TQParams = {}> {
  public readonly path: string;

  constructor(path: string) {
    this.path = path;
  }

  public url(params: TParams, queryParams?: TQParams): string {
    return UrlBuilder.build(this.path, params, queryParams);
  }
}
